import TYPES from '../../types';

// Domain
import {
  BaseGoalsDto,
} from '@/modules/flagship/investor-goal/base-goals/domain/dtos/base-goals-dto';
import {
  BaseGoalsRepository,
} from '@/modules/flagship/investor-goal/base-goals/domain/repositories/base-goals-repository';
import Command from '@/modules/shared/domain/use-cases/command';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';

@Injectable()
export default class UpdateBaseGoalsCommand extends Command<BaseGoalsDto> {
  @Inject(TYPES.BASE_GOALS_REPOSITORY)
  private readonly repository!: BaseGoalsRepository;

  internalExecute(base_goals_dto: BaseGoalsDto) {
    return this.repository.update(base_goals_dto);
  }
}
